import { render } from "./GoalLib.vue?vue&type=template&id=df08f8ec&scoped=true"
import script from "./GoalLib.vue?vue&type=script&lang=js"
export * from "./GoalLib.vue?vue&type=script&lang=js"

import "./GoalLib.vue?vue&type=style&index=0&id=df08f8ec&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df08f8ec"]])

export default __exports__